import React, { useState,useEffect } from "react";
import Select from "react-select";

function AlertPlus() {
  const [weeks, setWeeks] = useState();
  const [days, setDays] = useState();
  const [hours, setHours] = useState();
  const [minutes, setMinutes] = useState();
  const [machineEmail, setMachineEmail] = useState();
  const [physicalEmail, setPhysicalEmail] = useState();
  const [supplyEmail, setSupplyEmail] = useState();
  const [setting, setSetting] = useState();
  const [settingOptions, setSettingsOptions] = useState([
    { label: "test", value: "test" },
    { label: "test2", value: "test2" },
  ]);
  const [selectedSetting, setSelectedSetting] = useState();
  const [warningCassette1, setWarningCassette1] = useState();
  const [warningCassette2, setWarningCassette2] = useState();
  const [warningCassette3, setWarningCassette3] = useState();
  const [warningCassette4, setWarningCassette4] = useState();
  const [criticalLevelCassette1, setCriticalLevelCassette1] = useState();
  const [criticalLevelCassette2, setCriticalLevelCassette2] = useState();
  const [criticalLevelCassette3, setCriticalLevelCassette3] = useState();
  const [criticalLevelCassette4, setCriticalLevelCassette4] = useState();
  const [copyTerminalSelect, setCopyTerminalSelect] = useState();
  const [copyTerminalOptions, setCopyTerminalOptions] = useState();
  const [machineState, setMachineState] = useState(false);
  const [inactiveThreshold, setInactiveThreshold] = useState(false);
  const [cashThreshold, setCashThreshold] = useState(false);
  const [schedule, setSchedule] = useState();
  const [auditEmail, setAuditEmail] = useState()
  const [enabledAudit, setEnabledAudit] = useState()
  const [sameForAll,setSameForAll] = useState()
  const [user,setUser] = useState()
  const [lastLogin,setLastLogin] = useState()
  const [noOfTerminal,setNoOfTerminal] = useState()
  const [activeNoOfUser,setSctiveNoOfUser] = useState()

  const handleReset = ()=>{
    setWeeks("")
    setDays("")
    setHours("")
    setMinutes("")
    setSupplyEmail("")
    setMachineEmail("")
    setPhysicalEmail("")
    setSetting("")
    setSelectedSetting("")
    setSelectedSetting("")
    setMachineState(false)
    setInactiveThreshold(false)
    setCashThreshold(false)
    setCriticalLevelCassette1("")
    setCriticalLevelCassette2("")
    setCriticalLevelCassette3("")
    setCriticalLevelCassette4("")
    setWarningCassette2("")
    setWarningCassette1("")
    setWarningCassette3("")
    setWarningCassette4("")
    setAuditEmail("")
  }


  useEffect(()=>{
    if(setting === "terminalAssigned")
    {
      console.log("api call for terminal assigned")
    }
    if(setting==="terminalLocatedState")
    {
      console.log("api call for terminal located state")
    }
    if(setting==="terminalLocatedDistrict")
    {
      console.log("api call for terminal located district")
    }
    if(setting==="singleTerminal")
    {
      console.log("api call for single terminal")
    }
  },[setting])

  const handleSubmit = ()=>{}
  const handleGoCopyTerminal = () => {}
  return (
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <h5 class="tbsub-title2">Username: {user}</h5>
                <h5 class="tbsub-title2">Last Login: {lastLogin}</h5>
              </div>
              <div class="col-md-3">
                <h5 class="tbsub-title2">No. of Terminals: {noOfTerminal}</h5>
                <h5 class="tbsub-title2">Active No. of Users: {activeNoOfUser}</h5>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6" onChange={(e) => setSetting(e.target.id)}>
                <h5 class="tbsub-title mb-3">View / Edit Setting for:</h5>
                <div class="row align-items-center">
                  <div class="col-sm-5">
                    <div class="mb-3">
                      <input
                        type="radio"
                        id="terminalAssigned"
                        name="customRadio"
                      />
                      <label class="" for="terminalAssigned">
                        Terminal Assigned to:
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-7">
                    <div class="form-group">
                      <Select
                        options={settingOptions}
                        value={selectedSetting}
                        onChange={(e) => setSelectedSetting(e)}
                        isDisabled={setting !== "terminalAssigned"}
                      />
                    </div>
                  </div>
                </div>
                <div class="row align-items-center">
                  <div class="col-sm-5">
                    <div class="mb-3">
                      <input
                        type="radio"
                        id="terminalLocatedState"
                        name="customRadio"
                      />
                      <label for="terminalLocatedState">
                        Terminals Located in:
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-7">
                    <div class="form-group">
                      <Select
                        options={settingOptions}
                        value={selectedSetting}
                        onChange={(e) => setSelectedSetting(e)}
                        isDisabled={setting !== "terminalLocatedState"}
                      />
                    </div>
                  </div>
                </div>
                <div class="row align-items-center">
                  <div class="col-sm-5">
                    <div class="mb-3">
                      <input
                        type="radio"
                        id="terminalLocatedDistrict"
                        name="customRadio"
                      />
                      <label for="terminalLocatedDistrict">
                        Terminals Located in:
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-7">
                    <div class="form-group">
                      <Select
                        options={settingOptions}
                        value={selectedSetting}
                        onChange={(e) => setSelectedSetting(e)}
                        isDisabled={setting !== "terminalLocatedDistrict"}
                      />
                    </div>
                  </div>
                </div>
                <div class="row align-items-center">
                  <div class="col-sm-5">
                    <div class="mb-3">
                      <input
                        type="radio"
                        id="singleTerminal"
                        name="customRadio"
                      />
                      <label for="singleTerminal">Single Terminal:</label>
                    </div>
                  </div>
                  <div class="col-sm-7">
                    <div class="form-group">
                      <Select
                        options={settingOptions}
                        value={selectedSetting}
                        onChange={(e) => setSelectedSetting(e)}
                        isDisabled={setting !== "singleTerminal"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="ml-4">
                  <h5 class="tbsub-title mb-3">Enable Notifications</h5>
                  <div class="form-check mb-3">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="enableNotification"
                      checked={machineState}
                      onChange={() => setMachineState(!machineState)}
                    />
                    <label class="form-check-label" for="enableNotification">
                      Machine Status
                    </label>
                  </div>
                  <div class="form-check mb-3">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="ENchkbox2"
                      checked={inactiveThreshold}
                      onChange={() => setInactiveThreshold(!inactiveThreshold)}
                    />
                    <label class="form-check-label" for="ENchkbox2">
                      Inactive Treshold
                    </label>
                  </div>
                  <div class="form-check mb-3">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="ENchkbox3"
                      checked={cashThreshold}
                      onChange={() => setCashThreshold(!cashThreshold)}
                    />
                    <label class="form-check-label" for="ENchkbox3">
                      Cash Treshold
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <h5 class="tbsub-title mb-3">Inactive Treshold</h5>
                <div class="form-group row">
                  <label
                    for="example-text-input"
                    class="col-md-4 col-form-label"
                  >
                    Weeks
                  </label>
                  <div class="col-md-8">
                    <input
                      class="form-control"
                      type="text"
                      value={weeks}
                      onChange={(e) => setWeeks(e.target.value)}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for="example-text-input"
                    class="col-md-4 col-form-label"
                  >
                    Days
                  </label>
                  <div class="col-md-8">
                    <input
                      class="form-control"
                      type="text"
                      value={days}
                      onChange={(e) => setDays(e.target.value)}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for="example-text-input"
                    class="col-md-4 col-form-label"
                  >
                    Hours
                  </label>
                  <div class="col-md-8">
                    <input
                      class="form-control"
                      type="text"
                      value={hours}
                      onChange={(e) => setHours(e.target.value)}
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for="example-text-input"
                    class="col-md-4 col-form-label"
                  >
                    Minutes
                  </label>
                  <div class="col-md-8">
                    <input
                      class="form-control"
                      type="text"
                      value={minutes}
                      onChange={(e) => setMinutes(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="form-group">
                      <label class="control-label">
                        Copy Data from Terminal
                      </label>
                      <div class="form-group">
                        <Select options={copyTerminalOptions} value={copyTerminalSelect} />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4 mt-4">
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-block btn-primary w-md"
                        onClick={()=>handleGoCopyTerminal()}
                      >
                        GO
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4 table-responsive">
              <table class="table tblbordernone">
                <thead>
                  <tr>
                    <th>
                      <h5 class="tbsub-title">Cash Treshold</h5>
                    </th>
                    <th>
                      <h5 class="tbsub-title">Cassette 1</h5>
                    </th>
                    <th>
                      <h5 class="tbsub-title">Cassette 2</h5>
                    </th>
                    <th>
                      <h5 class="tbsub-title">Cassette 3</h5>
                    </th>
                    <th>
                      <h5 class="tbsub-title">Cassette 4</h5>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Warning Level:</td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        value={warningCassette1}
                        onChange={(e) => setWarningCassette1(e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        value={warningCassette2}
                        onChange={(e) => setWarningCassette2(e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        value={warningCassette3}
                        onChange={(e) => setWarningCassette3(e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        value={warningCassette4}
                        onChange={(e) => setWarningCassette4(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Critical Level:</td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        value={criticalLevelCassette1}
                        onChange={(e) =>
                          setCriticalLevelCassette1(e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        value={criticalLevelCassette2}
                        onChange={(e) =>
                          setCriticalLevelCassette2(e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        value={criticalLevelCassette3}
                        onChange={(e) => {
                          setCriticalLevelCassette3(e.target.value);
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        value={criticalLevelCassette4}
                        onChange={(e) => {
                          setCriticalLevelCassette4(e.target.value);
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mt-5 d-flex" onChange={(e) => setSchedule(e.target.id)}>
              <div class="mb-3">
                <input type="radio" id="noSchedule" name="customRadio" />
                <label for="noSchedule">No Schedules</label>
              </div>
              <div class=" mb-3 ml-3">
                <input type="radio" id="daySchedule" name="customRadio" />
                <label for="daySchedule">Day Schedules</label>
              </div>
              <div class="mb-3 ml-3">
                <input
                  type="radio"
                  id="weekDayandWeekendSchedules"
                  name="customRadio"
                />
                <label for="weekDayandWeekendSchedules">
                  Week day and weekend schedules
                </label>
              </div>
            </div>
            <div class="mt-4">
              <h5 class="tbsub-title">Weekly Shift:</h5>
              <div class="d-flex">
                <div>Shift 1:</div>
                <div class="form-check mb-3 ml-3">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="sameForAll"
                    checked={sameForAll}
                    onChange={()=>setSameForAll(!sameForAll)}
                  />
                  <label class="form-check-label" for="sameForAll">
                    Same for all
                  </label>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-4">
                  <div class="form-group row">
                    <label
                      for="example-text-input"
                      class="col-md-5 col-form-label"
                    >
                      Machine Email
                    </label>
                    <div class="col-md-7">
                      <input
                        class="form-control"
                        type="text"
                        value={machineEmail}
                        onChange={(e) => setMachineEmail(e.target.value)}
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      for="example-text-input"
                      class="col-md-5 col-form-label"
                    >
                      Physical Email
                    </label>
                    <div class="col-md-7">
                      <input
                        class="form-control"
                        type="text"
                        value={physicalEmail}
                        onChange={(e) => setPhysicalEmail(e.target.value)}
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      for="example-text-input"
                      class="col-md-5 col-form-label"
                    >
                      Supply Email
                    </label>
                    <div class="col-md-7">
                      <input
                        class="form-control"
                        type="text"
                        value={supplyEmail}
                        onChange={(e) => setSupplyEmail(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="form-group row">
                <label for="example-text-input" class="col-md-2 col-form-label">
                  Audit Email
                </label>
                <div class="col-md-6">
                  <input
                    class="form-control"
                    type="text"
                    value={auditEmail}
                    onChange={(e) => setAuditEmail(e.target.value)}
                  />
                </div>
              </div>
              {/*  */}
              <div class="form-check mb-3">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="shiftchkbox1"
                  checked={enabledAudit}
                  onChange={()=>setEnabledAudit(!enabledAudit)}
                />
                <label class="form-check-label" for="shiftchkbox1">
                  Enable AlertPlus Auditing
                </label>
              </div>
              {/*  */}
              <div className="mt-3">
                <h6>
                  AlertPlus Auditing will send a copy of every notification to
                  the address entered above, in addition to any configured email
                  address or pager numbers.
                </h6>
              </div>
              {/*  */}
              <div className="row d-flex justify-content-center">
              <span
                class="input-group-text ml-4"
                role="button"
                onClick={() => handleSubmit()}
              >
                Submit
              </span>
              {/*  */}
              <span
                class="input-group-text ml-4"
                role="button"
                onClick={() => handleReset()}
              >
                Reset
              </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlertPlus;
